const Constants = {
  URL: "https://server.cdaautomax.com",
  URLFILES: "http://3.19.39.85",
  DATADICCIONARIO: [],
};

export default Constants;
